import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useEffect, useMemo } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

// Sharp, minimal marker — no default leaflet icon PNG dependency
function makeIcon(rate) {
  const html = `<div style="background:#0A0A0A;color:#fff;padding:6px 10px;border:1px solid #0A0A0A;font-family:'IBM Plex Sans',sans-serif;font-size:12px;font-weight:600;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,0.15)">$${rate}/hr</div>`;
  return L.divIcon({
    html,
    className: "denshare-pin",
    iconSize: [0, 0],
    iconAnchor: [30, 14],
  });
}

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) {
      map.setView([points[0].lat, points[0].lng], 13);
    } else {
      const b = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
      map.fitBounds(b, { padding: [40, 40], maxZoom: 12 });
    }
  }, [points, map]);
  return null;
}

export default function ListingsMap({ listings }) {
  const points = useMemo(
    () => listings.filter((l) => typeof l.lat === "number" && typeof l.lng === "number"),
    [listings]
  );

  const center = points.length
    ? [points[0].lat, points[0].lng]
    : [40.7223, -73.9942];

  return (
    <div className="border border-neutral-200 overflow-hidden" data-testid="listings-map">
      <MapContainer
        center={center}
        zoom={12}
        style={{ height: "70vh", width: "100%" }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points}/>
        {points.map((l) => (
          <Marker key={l.id} position={[l.lat, l.lng]} icon={makeIcon(l.hourly_rate)}>
            <Popup>
              <div style={{ minWidth: 200 }}>
                <img src={l.photos?.[0]} alt="" style={{ width: "100%", height: 110, objectFit: "cover", marginBottom: 8 }}/>
                <div style={{ fontFamily: "'Cabinet Grotesk',sans-serif", fontWeight: 600, marginBottom: 2 }}>{l.title}</div>
                <div style={{ color: "#6B7280", fontSize: 12, marginBottom: 6 }}>{l.neighborhood} · ${l.hourly_rate}/hr</div>
                <Link
                  to={`/listings/${l.id}`}
                  data-testid={`map-view-${l.id}`}
                  style={{ display: "inline-block", padding: "6px 10px", background: "#0A0A0A", color: "#fff", fontSize: 12, textDecoration: "none" }}
                >
                  View den →
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
